import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "@splidejs/splide/css/core";

export const contentSlider = () => ({
  init() {
    const splide = new Splide(this.$refs.splide, {
      type: "loop",
      drag: "free",
      focus: "center",
      autoWidth: true,
      autoScroll: {
        speed: 0.5,
        pauseOnHover: true,
        pauseOnFocus: true,
        rewind: true,
      },
      gap: "1rem",
      padding: "10%",
      perMove: 1,
      breakpoints: {
        640: {
          autoScroll: false,
        },
      },
    }).mount({ AutoScroll });

    // Resume autoscroll after manual navigation
    let resumeTimer;
    const scheduleAutoScrollResume = () => {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        const autoScroll = splide.Components.AutoScroll;
        if (autoScroll) {
          autoScroll.play();
        }
      }, 1000);
    };

    splide.on("click", scheduleAutoScrollResume);
    splide.on("moved", scheduleAutoScrollResume);
  },
});
